import { CheckIcon, XIcon, BookOpenIcon, GiftIcon, ShieldCheckIcon, SmartphoneIcon, ZapIcon, RefreshCwIcon, TargetIcon, SlidersHorizontalIcon, LayersIcon, SearchIcon, SparklesIcon, WrenchIcon } from 'lucide-react';
import { MetaPixel } from './components/MetaPixel';
import { CtaButton } from './components/CtaButton';
import { Countdown } from './components/Countdown';
import { FloatingCta } from './components/FloatingCta';
import { ScarcityBar } from './components/ScarcityBar';
import { Testimonials } from './components/Testimonials';
import { FaqSection } from './components/FaqSection';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/kceDKyh7tDnEgCwcrfGerK/1.png';
const BONO1_IMG = 'https://cdn.magicpatterns.com/uploads/192nQQ3LAunTwgpdFohjRX/BONO_1_SOLDADURA.png';
const BONO2_IMG = 'https://cdn.magicpatterns.com/uploads/7U7Ek2WfQ8PZFbpaLsbJ7o/BONO_2_SOLDADURA.png';
const BONO3_IMG = 'https://cdn.magicpatterns.com/uploads/5ajy4DY1aYXJssanDje6vu/BONO_3_SOLDADURA.png';
const BONO4_IMG = 'https://cdn.magicpatterns.com/uploads/njuzcrqk55iastMfuuNPK5/BONO_4_SOLDADURA.png';
const BONO5_IMG = 'https://cdn.magicpatterns.com/uploads/wtSkQYEHsaWwLzks5h3pSo/BONO_5_SOLDADURA.png';
const STATS = [{
  value: '+300',
  label: 'Soluciones prácticas'
}, {
  value: '+1.200',
  label: 'Soldadores'
}, {
  value: '6',
  label: 'Manuales Maestros'
}, {
  value: '99%',
  label: 'Lo recomienda'
}];
const PAIN = ['Pierdes material por configuraciones incorrectas.', 'Adivinas el amperaje cada vez que cambia el espesor.', 'Tus cordones quedan diferentes en cada práctica.', 'No sabes si la soldadura realmente soportará la carga.', 'Cada proyecto comienza con dudas e improvisación.'];
const GAIN = ['Sabrás exactamente qué configuración usar antes de empezar.', 'Conseguirás cordones más limpios, fuertes y uniformes.', 'Reducirás el desperdicio de electrodos y material.', 'Corregirás cualquier error con rapidez.', 'Soldarás con la seguridad de alguien que sabe lo que hace.'];
const FOR_YOU = ['Tienes una soldadora, pero nunca aprendiste a usarla bien.', 'Aprendes en YouTube, pero cada video dice algo diferente.', 'Siempre dudas antes de configurar la máquina.', 'Desperdicias electrodos y material por errores evitables.', 'Quieres fabricar tus propios proyectos con confianza.', 'Quieres dejar de depender de otros para reparaciones.', 'Quieres resultados que se vean realmente profesionales.'];
const MANUALS = [{
  n: '1',
  icon: TargetIcon,
  title: 'Método Cero Errores™',
  desc: 'Qué hacer antes de soldar para evitar los errores más comunes desde el primer día.'
}, {
  n: '2',
  icon: ZapIcon,
  title: 'Control Total del Arco™',
  desc: 'Domina la técnica para conseguir cordones limpios, uniformes y resistentes.'
}, {
  n: '3',
  icon: SlidersHorizontalIcon,
  title: 'Código Maestro de Configuración™',
  desc: 'Configura correctamente tu soldadora en segundos sin volver a adivinar.'
}, {
  n: '4',
  icon: LayersIcon,
  title: 'Soldaduras Sin Límites™',
  desc: 'Aprende a soldar con seguridad en cualquier posición.'
}, {
  n: '5',
  icon: SearchIcon,
  title: 'Laboratorio del Soldador™',
  desc: 'Detecta y corrige cualquier defecto con una simple inspección visual.'
}, {
  n: '6',
  icon: SparklesIcon,
  title: 'Acabado Profesional™',
  desc: 'Consigue terminaciones que transmitan calidad y profesionalismo.'
}];
const IMMEDIATE = ['Los 6 Manuales Maestros en formato digital.', 'Más de 300 soluciones prácticas paso a paso.', 'Tablas de configuración listas para consultar.', 'Guías visuales de diagnóstico de errores.', 'Checklists de consulta rápida.', 'Acceso desde celular, tablet o computadora.'];
const BONUSES = [{
  n: '1',
  title: 'Centro de Costos del Soldador™',
  desc: 'Calcula correctamente cuánto cobrar por cada trabajo.',
  value: '$47',
  img: BONO1_IMG
}, {
  n: '2',
  title: 'Acabado Premium™',
  desc: 'Haz que cada proyecto luzca como salido de un taller profesional.',
  value: '$37',
  img: BONO2_IMG
}, {
  n: '3',
  title: 'Biblioteca de Cordones Perfectos™',
  desc: 'Compara, identifica y corrige cualquier defecto de soldadura.',
  value: '$67',
  img: BONO3_IMG
}, {
  n: '4',
  title: 'Kit Maestro para Conseguir Clientes™',
  desc: 'Plantillas y estrategias para conseguir tus primeros trabajos.',
  value: '$57',
  img: BONO4_IMG
}, {
  n: '5',
  title: 'Auditoría Profesional del Taller™',
  desc: 'Proyecta una imagen profesional y genera más confianza.',
  value: '$37',
  img: BONO5_IMG
}];
function SectionHeading({
  children,
  kicker
}: {
  children: React.ReactNode;
  kicker?: string;
}) {
  return <div className="mb-6 text-center" data-id="element-0" data-mp="zzoew6bcaeqx">
      {kicker && <p className="mb-2 text-xs font-cond font-semibold uppercase tracking-[0.2em] text-amber-400" data-id="element-1" data-mp="vvp484cqqa5h">
          {kicker}
        </p>}
      <h2 className="font-display text-3xl leading-[1.05] text-white sm:text-4xl" data-id="element-2" data-mp="3gmh6ugfgzi9v">
        {children}
      </h2>
    </div>;
}
export function App() {
  return <div className="min-h-full w-full bg-[#0d0d0f] text-white" data-id="element-3" data-mp="1w5zuc34l8cg6">
      <MetaPixel data-id="element-4" data-mp="2058rzj2r0uh0" />

      {/* Announcement strip */}
      <div className="w-full bg-amber-500 py-2 px-4 text-center" data-id="element-5" data-mp="203xjx729t0k3">
        <p className="font-cond text-xs font-semibold uppercase tracking-wide text-[#0d0d0f] sm:text-sm" data-id="element-6" data-mp="254bmwap0lkb9">
          🔥 Oferta de lanzamiento · Acceso de por vida por solo $15 USD
        </p>
      </div>

      <main className="mx-auto w-full max-w-md px-4 sm:max-w-xl" data-id="element-7" data-mp="2euenavygu0jm">
        {/* HERO */}
        <section className="pt-8 pb-4 text-center" data-id="element-8" data-mp="2jsy7aqti129c">
          <div className="mb-4 flex items-center justify-center gap-2" data-id="element-9" data-mp="2nvl6xdwevrh3">
            <WrenchIcon className="h-5 w-5 text-amber-400" data-id="element-10" data-mp="2nwe2rjtu0wkg" />
            <span className="font-display text-lg tracking-wide text-white" data-id="element-11" data-mp="2suxq9oo2qgex">
              SISTEMA MAESTRO<span className="text-amber-400" data-id="element-12" data-mp="tid87b5bevq6"> DE SOLDADURA™</span>
            </span>
          </div>

          <h1 className="font-display text-[2.6rem] leading-[0.95] text-white sm:text-6xl" data-id="element-13" data-mp="yfv9cfd3c6nm">
            Deja de improvisar y consigue cordones{' '}
            <span className="text-amber-400" data-id="element-14" data-mp="21tok47aeh59x">fuertes y limpios</span>
          </h1>

          <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-neutral-300 sm:text-base" data-id="element-15" data-mp="1wubvpi3vrq58">
            Olvídate del ensayo y error, las configuraciones confusas y los videos
            interminables. El Sistema Maestro te guía <strong className="text-white" data-id="element-16" data-mp="2kqg82u0w08kb">paso a paso</strong> para
            configurar tu máquina, evitar los errores de principiante y soldar con
            confianza desde tus primeras prácticas.
          </p>

          <div className="my-6" data-id="element-17" data-mp="2tj9sf5v6xy51">
            <img src={HERO_MOCKUP} alt="Sistema Maestro de Soldadura — 6 manuales, bonos y acceso digital" className="mx-auto w-full max-w-sm drop-shadow-2xl" data-id="element-18" data-mp="2thglrqkkvdx1" />
          </div>

          <div id="hero-cta-anchor" data-id="element-19" data-mp="33eti3aj5w0lc" />
          <CtaButton data-id="element-20" data-mp="2yicv4jnp7s9u">Quiero el Sistema Maestro ahora</CtaButton>

          <div className="mt-4" data-id="element-21" data-mp="2yg083s332rpx">
            <Countdown data-id="element-22" data-mp="3i33bczrwlsoj" />
          </div>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-neutral-300" data-id="element-23" data-mp="3i4eh354wtaia">
            {['Acceso inmediato', 'Pago único', 'Acceso de por vida', 'Garantía de 7 días'].map(b => <li key={b} className="flex items-center gap-1.5" data-id="element-24" data-mp="387t9cc1i9lar">
                <CheckIcon className="h-4 w-4 text-amber-400" data-id="element-25" data-mp="3d2yuh8n32vxs" />
                {b}
              </li>)}
          </ul>

          <p className="mt-6 text-sm italic text-neutral-400" data-id="element-26" data-mp="2zbair6gqy9hc">
            Más que un curso… una guía de consulta para cada vez que vayas a soldar.
          </p>
        </section>

        {/* STATS */}
        <section className="my-6 grid grid-cols-2 gap-3 rounded-2xl border border-white/10 bg-[#16161a] p-4" data-id="element-27" data-mp="2pd4n36lj9zkx">
          {STATS.map(s => <div key={s.label} className="text-center" data-id="element-28" data-mp="2gfc2po0yg1qo">
              <div className="font-display text-3xl text-amber-400" data-id="element-29" data-mp="2kfuyft5yxry5">{s.value}</div>
              <div className="mt-0.5 text-[11px] font-cond uppercase tracking-wide text-neutral-400" data-id="element-30" data-mp="2khyyg00qy6t5">
                {s.label}
              </div>
            </div>)}
        </section>

        {/* PAIN vs GAIN */}
        <section className="py-8" data-id="element-31" data-mp="2qx7m230r2d50">
          <SectionHeading data-id="element-32" data-mp="2qw69tv7zzklp">
            Deja de dudar cada vez que enciendes tu máquina
          </SectionHeading>

          <div className="grid gap-4" data-id="element-33" data-mp="2lxl5bjlpqerg">
            <div className="rounded-2xl border border-red-500/20 bg-red-500/5 p-5" data-id="element-34" data-mp="2hwj3cv0evols">
              <h3 className="mb-3 font-cond text-lg font-semibold uppercase tracking-wide text-red-400" data-id="element-35" data-mp="2hym1617t2m12">
                Hoy…
              </h3>
              <ul className="space-y-3" data-id="element-36" data-mp="285wx3rel4afr">
                {PAIN.map(p => <li key={p} className="flex gap-2.5 text-sm text-neutral-300" data-id="element-37" data-mp="237ve16h5sb4a">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-38" data-mp="235sftz5urboh" />
                    {p}
                  </li>)}
              </ul>
            </div>

            <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5" data-id="element-39" data-mp="1u7qefii7ih0o">
              <h3 className="mb-3 font-cond text-lg font-semibold uppercase tracking-wide text-amber-400" data-id="element-40" data-mp="9ocumq9l7a5v">
                Con el Sistema Maestro…
              </h3>
              <ul className="space-y-3" data-id="element-41" data-mp="ipb4hp6pibwd">
                {GAIN.map(g => <li key={g} className="flex gap-2.5 text-sm text-neutral-200" data-id="element-42" data-mp="nof9e3mllngw">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" data-id="element-43" data-mp="nmb8zvnwr6ld" />
                    {g}
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* FOR YOU */}
        <section className="py-8" data-id="element-44" data-mp="3w47h2yz1ij99">
          <SectionHeading kicker="¿Es para ti?" data-id="element-45" data-mp="3w363amqn3inu">
            El Sistema Maestro fue creado para ti si…
          </SectionHeading>
          <ul className="grid gap-3 rounded-2xl border border-white/10 bg-[#16161a] p-5" data-id="element-46" data-mp="33fte04t3gwqu">
            {FOR_YOU.map(f => <li key={f} className="flex gap-2.5 text-sm text-neutral-200" data-id="element-47" data-mp="38e4n2dbkf380">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" data-id="element-48" data-mp="2f7dkynnr32n8" />
                {f}
              </li>)}
          </ul>
          <p className="mt-4 text-center text-sm text-neutral-300" data-id="element-49" data-mp="2k4n7nvjr907d">
            Si te identificaste con alguno de estos puntos,{' '}
            <strong className="text-amber-400" data-id="element-50" data-mp="2p3gnvvqff5b8">este sistema es para vos.</strong>
          </p>
        </section>

        {/* MANUALS */}
        <section className="py-8" data-id="element-51" data-mp="1whf3jgy2bx6x">
          <SectionHeading kicker="📦 Todo lo que incluye" data-id="element-52" data-mp="1wi6wsl46tiu1">
            Los 6 Manuales Maestros
          </SectionHeading>
          <div className="grid gap-3" data-id="element-53" data-mp="21ddwlhuc63do">
            {MANUALS.map(m => {
            const Icon = m.icon;
            return <div key={m.n} className="flex gap-3 rounded-2xl border border-white/10 bg-[#16161a] p-4" data-id="element-54" data-mp="2b61pw2m3xp7n">
                  <div className="flex h-12 w-12 shrink-0 flex-col items-center justify-center rounded-xl bg-amber-500/15 ring-1 ring-amber-500/40" data-id="element-55" data-mp="1dobigjywusnx">
                    <BookOpenIcon className="h-4 w-4 text-amber-400" data-id="element-56" data-mp="3vyh5dqf2j13i" />
                    <span className="font-display text-sm leading-none text-amber-400" data-id="element-57" data-mp="3ry6ovjtngsae">
                      {m.n}
                    </span>
                  </div>
                  <div className="min-w-0" data-id="element-58" data-mp="3n0x2ye5gyyrb">
                    <div className="flex items-center gap-2" data-id="element-59" data-mp="3i09270rfv3jw">
                      <Icon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-60" data-mp="3i23nwhajazp1" />
                      <h3 className="font-cond text-base font-semibold text-white" data-id="element-61" data-mp="3d27h6aagcu5s">
                        {m.title}
                      </h3>
                    </div>
                    <p className="mt-1 text-sm leading-snug text-neutral-400" data-id="element-62" data-mp="347jgyyjqi2nu">{m.desc}</p>
                  </div>
                </div>;
          })}
          </div>
        </section>

        {/* IMMEDIATE */}
        <section className="py-8" data-id="element-63" data-mp="2u8txx2g3qc60">
          <SectionHeading kicker="📲 Acceso inmediato" data-id="element-64" data-mp="2ubzji7piuvwz">
            ¿Qué recibirás al instante?
          </SectionHeading>
          <ul className="grid gap-3 rounded-2xl border border-white/10 bg-[#16161a] p-5" data-id="element-65" data-mp="2fnpuwvrq5s04">
            {IMMEDIATE.map(i => <li key={i} className="flex gap-2.5 text-sm text-neutral-200" data-id="element-66" data-mp="2knklszbi2hl6">
                <SmartphoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" data-id="element-67" data-mp="26n9u5u2d8yyy" />
                {i}
              </li>)}
          </ul>
          <p className="mt-4 text-center text-sm text-neutral-300" data-id="element-68" data-mp="2aqfu6jyvxtwz">
            Cada vez que tengas una duda en el taller, abres el manual correspondiente y
            encuentras la respuesta en minutos.
          </p>
        </section>

        {/* MID CTA */}
        <section className="py-4" data-id="element-69" data-mp="2pkkqb5spbca6">
          <div className="rounded-2xl border border-amber-500/30 bg-[#16161a] p-5 text-center" data-id="element-70" data-mp="2pldqfnx5n3jc">
            <p className="mb-4 font-cond text-lg font-semibold text-white" data-id="element-71" data-mp="2tleg64ppf15p">
              Todo esto, desde tu celular, por un pago único
            </p>
            <CtaButton data-id="element-72" data-mp="3m3s2p85lb0ph">Quiero el Sistema Maestro</CtaButton>
            <div className="mt-4" data-id="element-73" data-mp="3m5cy0zzqanoe">
              <Countdown data-id="element-74" data-mp="1ao1dz8mcjkd6" />
            </div>
          </div>
        </section>

        {/* BONUSES */}
        <section className="py-8" data-id="element-75" data-mp="15q868b5eaias">
          <SectionHeading kicker="🎁 Además recibirás gratis" data-id="element-76" data-mp="15ox044oh8ygi">
            5 Bonos Exclusivos
          </SectionHeading>
          <div className="grid gap-4" data-id="element-77" data-mp="1kg71o65kffmk">
            {BONUSES.map(b => <div key={b.n} className="overflow-hidden rounded-2xl border border-white/10 bg-[#16161a]" data-id="element-78" data-mp="1ffrpvj0xmg6p">
                {b.img && <div className="bg-white" data-id="element-79" data-mp="mrvvikyu50d3">
                    <img src={b.img} alt={`Bono ${b.n} — ${b.title}`} className="mx-auto w-full max-w-xs" loading="lazy" data-id="element-80" data-mp="msyiiht1einq" />
                  </div>}
                <div className="flex items-start gap-3 p-4" data-id="element-81" data-mp="2d16xperwk4r7">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/15 ring-1 ring-amber-500/40" data-id="element-82" data-mp="284q8eh8yvkcj">
                    <GiftIcon className="h-5 w-5 text-amber-400" data-id="element-83" data-mp="hoo02t582yg9" />
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-84" data-mp="mmg1cdrrbwx4">
                    <span className="text-[11px] font-cond uppercase tracking-widest text-amber-400" data-id="element-85" data-mp="qn00fmvw5alw">
                      Bono #{b.n}
                    </span>
                    <h3 className="font-cond text-base font-semibold text-white" data-id="element-86" data-mp="vki16pzr8jit">
                      {b.title}
                    </h3>
                    <p className="mt-1 text-sm text-neutral-400" data-id="element-87" data-mp="15k8tqm4r8og9">{b.desc}</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-amber-500/15 px-2.5 py-1 text-xs font-semibold text-amber-300" data-id="element-88" data-mp="1aaz1u74kf5en">
                    Valor {b.value}
                  </span>
                </div>
              </div>)}
          </div>
        </section>

        {/* OFFER */}
        <section className="py-8" data-id="element-89" data-mp="1oaqlandupe01">
          <SectionHeading kicker="🏆 Oferta especial de lanzamiento" data-id="element-90" data-mp="1oc1pupf4eps7">
            Todo lo que recibirás hoy
          </SectionHeading>

          <div className="rounded-2xl border border-amber-500/40 bg-[#16161a] p-5" data-id="element-91" data-mp="1ycu9uczon8e4">
            <ul className="space-y-3 border-b border-white/10 pb-4" data-id="element-92" data-mp="1ti6tj1eu1kam">
              <li className="flex items-center justify-between gap-3 text-sm" data-id="element-93" data-mp="1ohsjxexl22ah">
                <span className="flex items-center gap-2 text-neutral-200" data-id="element-94" data-mp="1kg7c47zwoe75">
                  <CheckIcon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-95" data-mp="2h5eyfi8cmrc4" />
                  6 Manuales Maestros de consulta
                </span>
                <span className="shrink-0 font-cond text-neutral-500 line-through" data-id="element-96" data-mp="2c7wpvsy8ue4n">$492</span>
              </li>
              <li className="flex items-center justify-between gap-3 text-sm" data-id="element-97" data-mp="27e26kqmjw163">
                <span className="flex items-center gap-2 text-neutral-200" data-id="element-98" data-mp="23di91ly2evjf">
                  <CheckIcon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-99" data-mp="2zwfv1zlzyasi" />
                  5 Bonos exclusivos
                </span>
                <span className="shrink-0 font-cond text-neutral-500 line-through" data-id="element-100" data-mp="2v3wjt9as7rqv">$245</span>
              </li>
            </ul>

            <div className="flex items-center justify-between py-4" data-id="element-101" data-mp="ta9u6zamu81o">
              <span className="font-cond text-sm uppercase tracking-wide text-neutral-400" data-id="element-102" data-mp="y6h3n228m1od">
                Valor total del sistema
              </span>
              <span className="font-display text-2xl text-neutral-500 line-through" data-id="element-103" data-mp="ogp3ztfa6id1">
                $737 USD
              </span>
            </div>

            <div className="rounded-xl bg-amber-500/10 p-4 text-center" data-id="element-104" data-mp="ag4kev1jkiih">
              <p className="text-sm text-neutral-300" data-id="element-105" data-mp="fhk4ajrzgiza">Pero hoy no pagarás $737…</p>
              <p className="mt-1 font-cond text-sm uppercase tracking-wide text-amber-400" data-id="element-106" data-mp="jrvsbkusuul">
                Accede hoy por solo
              </p>
              <div className="mt-1 font-display text-6xl leading-none text-white" data-id="element-107" data-mp="5il6jw8ra7r2">
                $15<span className="text-4xl" data-id="element-108" data-mp="1uxsoeept8lm8">.00</span>
                <span className="ml-1 align-top text-lg text-amber-400" data-id="element-109" data-mp="1zw42x2r1vkas">USD</span>
              </div>

              <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs text-neutral-300" data-id="element-110" data-mp="3kdvb5ylbbm7y">
                {['Pago único', 'Sin suscripciones', 'Acceso inmediato', 'Acceso de por vida'].map(b => <span key={b} className="flex items-center gap-1" data-id="element-111" data-mp="3u5smr6g8gg77">
                      <CheckIcon className="h-3.5 w-3.5 text-amber-400" data-id="element-112" data-mp="3pd7ui9cz6b5s" />
                      {b}
                    </span>)}
              </div>

              <div className="mt-4 flex items-center justify-center gap-2 rounded-lg bg-[#0d0d0f] px-3 py-2 text-xs text-neutral-300" data-id="element-113" data-mp="2yg5krfco2ra">
                <RefreshCwIcon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-114" data-mp="gwd7828nuzct" />
                El cambio de moneda es <strong className="text-white" data-id="element-115" data-mp="bzwe0tmltusv">&nbsp;automático</strong>: pagas el equivalente en tu moneda local.
              </div>
            </div>

            <p className="mt-4 text-center text-xs italic text-neutral-400" data-id="element-116" data-mp="2dq7w6gy71rrd">
              Menos de lo que cuesta un paquete de electrodos… y una herramienta que
              podrás consultar durante años.
            </p>

            <div className="mt-5" data-id="element-117" data-mp="1wv3pscy7r8wj">
              <ScarcityBar data-id="element-118" data-mp="1wu2fwbsxosge" />
            </div>

            <div className="mt-5" data-id="element-119" data-mp="21m297lei0n40">
              <CtaButton data-id="element-120" data-mp="21nwuj0tomh8m">Quiero el Sistema Maestro de Soldadura</CtaButton>
            </div>
            <div className="mt-4" data-id="element-121" data-mp="26kdj1w4smxm8">
              <Countdown data-id="element-122" data-mp="26nrjuzxt6yrk" />
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="py-8" data-id="element-123" data-mp="190auu3nkrwr1">
          <SectionHeading kicker="⭐ Lo que dicen los soldadores" data-id="element-124" data-mp="1dw7xx89tv6lv">
            Resultados reales en el taller
          </SectionHeading>
          <Testimonials data-id="element-125" data-mp="1iujahqribv7s" />
        </section>

        {/* GUARANTEE */}
        <section className="py-8" data-id="element-126" data-mp="1nvgxqhrdjfg5">
          <div className="rounded-2xl border border-amber-500/30 bg-[#16161a] p-6 text-center" data-id="element-127" data-mp="1nwid2yffao3o">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/15 ring-2 ring-amber-500/50" data-id="element-128" data-mp="2uazt1sycyryv">
              <ShieldCheckIcon className="h-8 w-8 text-amber-400" data-id="element-129" data-mp="nmr105a3uq1q" />
            </div>
            <h2 className="font-display text-2xl text-white sm:text-3xl" data-id="element-130" data-mp="inxly8f66qzg">
              Pruébalo 7 días sin riesgo
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-neutral-300" data-id="element-131" data-mp="dwfk7i5bomdf">
              Tu compra está protegida por una garantía de satisfacción de 7 días. Si
              revisas los Manuales, aplicas el sistema y sientes que no era lo que
              esperabas, solo escríbenos y te devolvemos el{' '}
              <strong className="text-white" data-id="element-132" data-mp="3w1r6v82cwrvd">100% de tu dinero</strong>.
            </p>
            <p className="mt-3 font-cond text-sm uppercase tracking-wide text-amber-400" data-id="element-133" data-mp="3r2xu5huw94w9">
              Sin preguntas. Sin trámites. Sin complicaciones.
            </p>
            <p className="mt-2 text-sm text-neutral-400" data-id="element-134" data-mp="1pccl84qfqwr0">
              Tú no asumes ningún riesgo. Nosotros sí.
            </p>
          </div>
        </section>

        {/* ORIGIN */}
        <section className="py-10" data-id="element-135" data-mp="1kb6vmfs2nplp">
          <SectionHeading kicker="⚙️ Nuestra misión" data-id="element-136" data-mp="2c7vpj2h7ziba">
            ¿Por qué creamos el Sistema Maestro de Soldadura™?
          </SectionHeading>
          <div className="rounded-2xl border border-white/10 bg-[#16161a] p-6" data-id="element-137" data-mp="27919g8an07uv">
            <div className="space-y-4 text-sm leading-relaxed text-neutral-300" data-id="element-138" data-mp="22g83xi7cgvhq">
              <p data-id="element-139" data-mp="1xj7xv7ahvsqm">
                Porque la mayoría de las personas no fracasan al soldar por falta de capacidad.
                <strong className="block pt-2 text-base text-white" data-id="element-140" data-mp="1thmfj6f6ym91">Fracasan porque nadie les enseña qué hacer antes de encender la máquina.</strong>
              </p>
              <p data-id="element-141" data-mp="1ji5a8q3uqadl">Aprenden viendo videos que se contradicen entre sí. Pierden material haciendo pruebas. Y terminan creyendo que la soldadura es mucho más difícil de lo que realmente es.</p>
              <div className="border-l-2 border-amber-400 pl-4" data-id="element-142" data-mp="3dwfzgzocz6jw">
                <p className="font-cond text-xl font-semibold text-white" data-id="element-143" data-mp="3dvwqw9klluij">El Sistema Maestro de Soldadura™ nació para cambiar eso.</p>
                <p className="mt-2" data-id="element-144" data-mp="3hevkjyfifofj">No es otro curso lleno de teoría. Es una guía de consulta práctica diseñada para decirte exactamente qué hacer cada vez que vayas a soldar.</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-8" data-id="element-145" data-mp="3q90jl54ss665">
          <SectionHeading kicker="Respuestas claras" data-id="element-146" data-mp="3v5quzf5nqdl8">
            Preguntas Frecuentes
          </SectionHeading>
          <FaqSection data-id="element-147" data-mp="2ygjbecolmejy" />
        </section>

        {/* FINAL CTA */}
        <section className="pb-16 pt-6" data-id="element-148" data-mp="32hczp75ydvdd">
          <div className="rounded-2xl border border-amber-500/40 bg-gradient-to-b from-amber-500/10 to-transparent p-6 text-center" data-id="element-149" data-mp="32ie8t63es7sg">
            <p className="font-cond text-sm font-semibold uppercase tracking-[0.16em] text-amber-400" data-id="element-150" data-mp="37iit777ftmny">La próxima vez que enciendas tu soldadora…</p>
            <h2 className="mt-3 font-display text-3xl leading-[1.05] text-white sm:text-4xl" data-id="element-151" data-mp="mqqivumtbfj5">
              Puedes seguir improvisando… o empezar con la seguridad de saber{' '}
              <span className="text-amber-400" data-id="element-152" data-mp="2164cyrr2muv">exactamente qué hacer.</span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-153" data-mp="3t7h8j3s243qf">
              Abre el Sistema Maestro, consulta la configuración correcta y empieza hoy a soldar con más precisión, confianza y resultados que realmente se vean profesionales.
            </p>

            <div className="mt-6" data-id="element-154" data-mp="70shz9bhq547">
              <CtaButton data-id="element-155" data-mp="3fg2em1wm2i4l">Quiero el Sistema Maestro de Soldadura</CtaButton>
            </div>
            <div className="mt-4" data-id="element-156" data-mp="3fdq0jztz4rwt">
              <Countdown data-id="element-157" data-mp="3ahr4rr6bg7md" />
            </div>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-neutral-300" data-id="element-158" data-mp="3aev4vxawr8va">
              {['Pago único de $15 USD', 'Acceso inmediato', 'Garantía de 7 días'].map(b => <li key={b} className="flex items-center gap-1.5" data-id="element-159" data-mp="2wpkyqxwvnh0n">
                  <CheckIcon className="h-4 w-4 text-amber-400" data-id="element-160" data-mp="2wo00ax7fzdxi" />
                  {b}
                </li>)}
            </ul>
          </div>

          <footer className="mt-10 border-t border-white/10 pt-7 text-center" data-id="element-161" data-mp="177xhfof28xh2">
            <p className="font-display text-lg text-white" data-id="element-162" data-mp="1bz5seow1gqwc">SISTEMA MAESTRO <span className="text-amber-400" data-id="element-163" data-mp="1c0gvemhntume">DE SOLDADURA™</span></p>
            <nav aria-label="Enlaces legales" className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-neutral-500" data-id="element-164" data-mp="xbayj56aogho">
              <a href="#terminos" className="hover:text-amber-400" data-id="element-165" data-mp="129m7zesogozd">Términos y Condiciones</a>
              <a href="#privacidad" className="hover:text-amber-400" data-id="element-166" data-mp="1pzqb7l1yempu">Política de Privacidad</a>
              <a href="mailto:contacto@sistemamaestrodesoldadura.com" className="hover:text-amber-400" data-id="element-167" data-mp="1uxi4aiec4evm">Contacto</a>
            </nav>
            <p className="mt-5 text-[11px] leading-relaxed text-neutral-600" data-id="element-168" data-mp="1kzu6tkpcgt9r">
              © 2025 Sistema Maestro de Soldadura™ — Todos los derechos reservados.
            </p>
          </footer>
        </section>
      </main>

      <FloatingCta data-id="element-169" data-mp="9l6x94gkwstu" />
    </div>;
}